import PropTypes from 'prop-types';
import React from 'react';

import { Grid, GridCell, ListCell, Status } from 'v1/components/shared';
import { cn } from 'v5/platform/dom/cn';

import { getFormattedEventDates } from 'v1/helpers/byModel/EventHelper';

const CellProductionItem = ({
  production,
  onSelect,
  layout = {},
  hideStatus
}) => {
  function onClick() {
    onSelect && onSelect(production);
  }

  return (
    <div className="tailwind-root contents">
      <ListCell
        className={cn(
          'CellProductionItem',
          layout.className,
          'Parent_hoverListener'
        )}
        padding="XS"
        onClick={onSelect ? onClick : null}
      >
        <Grid vcenter gutters="M">
          <GridCell
            className={cn(
              'relative flex items-center min-w-0 overflow-hidden font-semibold'
            )}
          >
            <span
              className="min-w-[4px] w-[4px] h-[30px] rounded shrink-0 bg-black mr-[5px] inline-block"
              style={{ backgroundColor: production.color }}
            />
            <span className="truncate min-w-0">
              {production.icon} {production.code} {production.title}
            </span>
          </GridCell>
          <GridCell width="auto" className="text-13-600">
            {getFormattedEventDates(production.production_date)}
          </GridCell>
          {!hideStatus && (
            <GridCell width="auto" className="text-right">
              <Status statusId={production.status_id} />
            </GridCell>
          )}
          {onSelect && (
            <GridCell width="auto" className="text-right Child_hoverListener">
              <img width="12px" src="/images/arrow_right.svg" alt="" />
            </GridCell>
          )}
        </Grid>
      </ListCell>
    </div>
  );
};

CellProductionItem.propTypes = {
  layout: PropTypes.object,
  hideStatus: PropTypes.bool
};

export default CellProductionItem;
